import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20warm%20gradient%20light%20streaks%20in%20deep%20red%20and%20amber%20tones%2C%20soft%20bokeh%20effect%2C%20modern%20streaming%20platform%20atmosphere%2C%20elegant%20dark%20cinematic%20texture%2C%20vibrant%20yet%20sophisticated%20visual%20style&width=1800&height=900&seq=hero-bg-jiujiu-01&orientation=landscape"
          alt="玖玖视频 - 高清视频在线观看平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-sm text-background-50/90 font-medium">每日更新 · 海量资源 · 免费观看</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            海量高清视频，
            <span className="block mt-1 bg-gradient-to-r from-primary-300 via-accent-300 to-primary-300 bg-clip-text text-transparent">
              随时随地免费观看
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            玖玖视频支持高清流畅播放，覆盖纪录片、教育、科技、美食等多个频道，多终端同步，畅享极致观影体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
            <div className="relative w-full sm:w-96">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你感兴趣的视频..."
                className="w-full px-5 py-3.5 pl-12 rounded-full text-sm bg-white/15 backdrop-blur-sm border border-white/25 text-background-50 placeholder-background-50/55 focus:outline-none focus:bg-white/25 focus:border-white/40 transition-all"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-background-50/60 text-lg"></i>
            </div>
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始观看
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: 'ri-4k-line', label: '超清画质' },
              { icon: 'ri-speed-up-line', label: '流畅播放' },
              { icon: 'ri-smartphone-line', label: '多端同步' },
              { icon: 'ri-vip-diamond-line', label: '免费观看' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-background-50/85">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}